module.exports = __webpack_public_path__ + "static/media/adjust (1).2a1be858.png";